// extracted by mini-css-extract-plugin
module.exports = {"bm-navbar":"bm-navbar","bm-navbar-menu":"bm-navbar-menu","bm-navbar-item":"bm-navbar-item","navbar-link":"navbar-link"};